// extracted by mini-css-extract-plugin
module.exports = {"McsBannerBase":"McsBannerPrimary_McsBannerBase__2dlZL","McsBannerTitle":"McsBannerPrimary_McsBannerTitle__1kd_O","McsBannerButton":"McsBannerPrimary_McsBannerButton__2XQ2P"};